__turbopack_context__.v({
  "dot": "Scroller-module__plLSoW__dot",
  "dots": "Scroller-module__plLSoW__dots",
  "fullWidth": "Scroller-module__plLSoW__fullWidth",
  "nav": "Scroller-module__plLSoW__nav",
  "scrollBox": "Scroller-module__plLSoW__scrollBox",
  "wrapper": "Scroller-module__plLSoW__wrapper",
});
